const getIsCardImprintEnabled = (configuration, isB2BSelected) => {
  const config = isB2BSelected
    ? configuration.app.solJourney.b2b
    : configuration.app.solJourney;

  return !!config.cashJourney.cardImprint;
};

module.exports = { getIsCardImprintEnabled };
